// ─────────────────────────────────────────────────────────────────────────────
// Saved videos — a lightweight "watch later / liked" list for students.
//
// This is a preference list (NOT a download and NOT the AIvo bookmark feature):
// students mark recordings they want to revisit and find them again under the
// "Saved videos" quick-access tile on My Learning. Persisted per-student in
// localStorage so it survives reloads without any backend work.
// ─────────────────────────────────────────────────────────────────────────────

const keyFor = (studentId) => `vc-saved-videos:${studentId || "anon"}`;

/** All saved video ids for this student (newest first). Never throws. */
export const getSavedVideoIds = (studentId) => {
  try {
    const raw = localStorage.getItem(keyFor(studentId));
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.map(String) : [];
  } catch {
    return [];
  }
};

export const isVideoSaved = (studentId, videoId) =>
  !!videoId && getSavedVideoIds(studentId).includes(String(videoId));

/**
 * Toggle a video in/out of the saved list and persist it.
 * Returns the new array of saved ids so callers can derive UI state.
 */
export const toggleSavedVideo = (studentId, videoId) => {
  if (!videoId) return getSavedVideoIds(studentId);
  const id = String(videoId);
  const ids = getSavedVideoIds(studentId);
  const next = ids.includes(id) ? ids.filter((v) => v !== id) : [id, ...ids];
  try {
    localStorage.setItem(keyFor(studentId), JSON.stringify(next));
  } catch {
    /* storage unavailable — non-fatal */
  }
  return next;
};
